/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgencyDto } from '../models/agency-dto';
import { apiAgencyCheckAgencyNameGet } from '../fn/agency/api-agency-check-agency-name-get';
import { ApiAgencyCheckAgencyNameGet$Params } from '../fn/agency/api-agency-check-agency-name-get';
import { apiAgencyCheckBarcodeGet } from '../fn/agency/api-agency-check-barcode-get';
import { ApiAgencyCheckBarcodeGet$Params } from '../fn/agency/api-agency-check-barcode-get';
import { apiAgencyCheckPinGet } from '../fn/agency/api-agency-check-pin-get';
import { ApiAgencyCheckPinGet$Params } from '../fn/agency/api-agency-check-pin-get';
import { apiAgencyGet } from '../fn/agency/api-agency-get';
import { ApiAgencyGet$Params } from '../fn/agency/api-agency-get';
import { apiAgencyGuidGet } from '../fn/agency/api-agency-guid-get';
import { ApiAgencyGuidGet$Params } from '../fn/agency/api-agency-guid-get';
import { apiAgencyPut } from '../fn/agency/api-agency-put';
import { ApiAgencyPut$Params } from '../fn/agency/api-agency-put';
import { NotificationMessage } from '../models/notification-message';

@Injectable({ providedIn: 'root' })
export class AgencyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAgencyCheckAgencyNameGet()` */
  static readonly ApiAgencyCheckAgencyNameGetPath = '/api/agency/check-agency-name';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyCheckAgencyNameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyCheckAgencyNameGet$Response(params?: ApiAgencyCheckAgencyNameGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgencyCheckAgencyNameGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyCheckAgencyNameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyCheckAgencyNameGet(params?: ApiAgencyCheckAgencyNameGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAgencyCheckAgencyNameGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgencyCheckBarcodeGet()` */
  static readonly ApiAgencyCheckBarcodeGetPath = '/api/agency/check-barcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyCheckBarcodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyCheckBarcodeGet$Response(params?: ApiAgencyCheckBarcodeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgencyCheckBarcodeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyCheckBarcodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyCheckBarcodeGet(params?: ApiAgencyCheckBarcodeGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAgencyCheckBarcodeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgencyCheckPinGet()` */
  static readonly ApiAgencyCheckPinGetPath = '/api/agency/check-pin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyCheckPinGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyCheckPinGet$Response(params?: ApiAgencyCheckPinGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAgencyCheckPinGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyCheckPinGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyCheckPinGet(params?: ApiAgencyCheckPinGet$Params, context?: HttpContext): Observable<void> {
    return this.apiAgencyCheckPinGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAgencyGet()` */
  static readonly ApiAgencyGetPath = '/api/agency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyGet$Response(params?: ApiAgencyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgencyDto>>> {
    return apiAgencyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyGet(params?: ApiAgencyGet$Params, context?: HttpContext): Observable<Array<AgencyDto>> {
    return this.apiAgencyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AgencyDto>>): Array<AgencyDto> => r.body)
    );
  }

  /** Path part for operation `apiAgencyPut()` */
  static readonly ApiAgencyPutPath = '/api/agency';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencyPut$Response(params?: ApiAgencyPut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAgencyPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencyPut(params?: ApiAgencyPut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAgencyPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiAgencyGuidGet()` */
  static readonly ApiAgencyGuidGetPath = '/api/agency/{guid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencyGuidGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyGuidGet$Response(params: ApiAgencyGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AgencyDto>> {
    return apiAgencyGuidGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencyGuidGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAgencyGuidGet(params: ApiAgencyGuidGet$Params, context?: HttpContext): Observable<AgencyDto> {
    return this.apiAgencyGuidGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AgencyDto>): AgencyDto => r.body)
    );
  }

}
